import { render, staticRenderFns } from "./order_receive_modal.vue?vue&type=template&id=25198dc0&scoped=true"
import script from "./order_receive_modal.vue?vue&type=script&lang=js"
export * from "./order_receive_modal.vue?vue&type=script&lang=js"
import style0 from "./order_receive_modal.vue?vue&type=style&index=0&id=25198dc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25198dc0",
  null
  
)

export default component.exports